import { NodeModel } from "../_model/NodeModel";
import { DecorationSugarCookerContinuous } from "./decorationSugarContinuous";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class SugarCookerContinuous extends NodeModel {
    constructor() {
        super("SugarCookerContinuous");

        this.type = new Types().SugarCookerContinuous;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 117.5;
        this.width = 219;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Processo/cozedorcontinuo.png");
        this.data = [new Properties({...this })];
        this.CurrentTempAr = null
        this.jokerCaption = {};


        this.decorate = async function(callback) {
            this.decorator = new DecorationSugarCookerContinuous();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new SugarCookerContinuous()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.CurrentTempAr = this.CurrentTempAr
            cloned.data = this.data.map(d => d.clone());
            cloned.jokerCaption = this.jokerCaption
            cloned.readOnly = this.readOnly;
			cloned.expressionVisible = this.expressionVisible;

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
            this.CurrentTempAr = node.CurrentTempAr
            this.jokerCaption = node.jokerCaption
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }

            if (node.CurrentTempAr) {
                this.CurrentTempAr = node.CurrentTempAr;
            }
            this.jokerCaption = node.jokerCaption;
        }

        // Para caso o nó tenha connections.
        // this.removeConnection = (connectionId) => {
        //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        // }
    }
}

export { SugarCookerContinuous };